import BaseAPI from '@/services/api/internal/tools/baseAPI';
import BaseService from '@/services/services/tools/baseService';
import { formatDateToInputDateTime } from '@/business/utils/dates';

const StaffInterventionsService = new BaseService({
  api: new BaseAPI('staff'),
});

function getInProgressItvsByTechId(id) {
  return StaffInterventionsService.getItems(
    {
      q: {
        event_datetime: {
          $gte: {
            $date: formatDateToInputDateTime(
              new Date(Date.now()).setHours(0, 0, 0, 0)
            ),
          },
        },
      },
    },
    `${process.env.P2H_BASE_URI}/staff/${id}/interventions_in_progress`
  ).then((items) =>
    items.sort((a, b) => {
      if (a.event_datetime < b.event_datetime) {
        return -1;
      }
      if (a.event_datetime > b.event_datetime) {
        return 1;
      }
      return a.property_code - b.property_code;
    })
  );
}

function getScheduledItvsByTechId(id) {
  return StaffInterventionsService.getItems(
    {
      q: {
        event_datetime: {
          $gte: {
            $date: formatDateToInputDateTime(
              new Date(Date.now()).setHours(0, 0, 0, 0)
            ),
          },
        },
      },
    },
    `${process.env.P2H_BASE_URI}/staff/${id}/planned_interventions`
  ).then((items) =>
    items.sort((a, b) => {
      if (a.event_datetime < b.event_datetime) {
        return -1;
      }
      if (a.event_datetime > b.event_datetime) {
        return 1;
      }
      return a.property_code - b.property_code;
    })
  );
}

function getInProgressItvsByPropertyId(id) {
  return StaffInterventionsService.getItems(
    {
      q: {
        event_datetime: {
          $gte: {
            $date: formatDateToInputDateTime(
              new Date(Date.now()).setHours(0, 0, 0, 0)
            ),
          },
        },
      },
    },
    `${process.env.P2H_BASE_URI}/property/${id}/interventions_in_progress`
  ).then((items) =>
    items.sort((a, b) => {
      if (a.event_datetime < b.event_datetime) {
        return -1;
      }
      if (a.event_datetime > b.event_datetime) {
        return 1;
      }
      return a.property_code - b.property_code;
    })
  );
}

function getScheduledItvsByPropertyId(id) {
  return StaffInterventionsService.getItems(
    {
      q: {
        event_datetime: {
          $gte: {
            $date: formatDateToInputDateTime(
              new Date(Date.now()).setHours(0, 0, 0, 0)
            ),
          },
        },
      },
    },
    `${process.env.P2H_BASE_URI}/property/${id}/planned_interventions`
  ).then((items) =>
    items.sort((a, b) => {
      if (a.event_datetime < b.event_datetime) {
        return -1;
      }
      if (a.event_datetime > b.event_datetime) {
        return 1;
      }
      return a.property_code - b.property_code;
    })
  );
}

export {
  getInProgressItvsByTechId,
  getScheduledItvsByTechId,
  getInProgressItvsByPropertyId,
  getScheduledItvsByPropertyId,
};

export default StaffInterventionsService;
